module.exports = __webpack_public_path__ + "img/feature-finances.c5c16e2b.png";